import React from "react";
export const DropdownOption = (props) => {
    return (React.createElement("button", { onClick: () => props.handleClick(props.termId, !props.active, props.hierarchy), className: "mb-4 filter-dropdown-option content-start w-full" },
        React.createElement("svg", { width: "18px", height: "24px", viewBox: "0 0 18 18" },
            React.createElement("rect", { x: "1", y: "1", width: "16", height: "16", strokeWidth: "1", fill: props.active ? "#141414" : "none" })),
        React.createElement("p", { className: "body small ml-2" }, props.name)));
};
